import { AppState } from "../../../../store/interfaces";

const selectParticipantsToPurchase = (state: AppState) => state.results.participantsToPurchase;
const selectNotificationHidden = (state: AppState) => state.results.notificationHidden;
const selectReloadResults = (state: AppState) => state.results.reload;

export { selectParticipantsToPurchase, selectNotificationHidden, selectReloadResults };
